import { FC, PropsWithChildren } from 'react';
import { CatModal } from '@blocks-react/components/Modal';
import { CatModalProps } from '../types';
import styles from '../CustomerValueAgreements.module.scss';
import cx from 'classnames';

export const CVAModal: FC<PropsWithChildren<CatModalProps>> = ({
  children,
  classname,
  ...modalProps
}) => {
  return (
    <CatModal size="lg" className={cx(classname,styles['cva-modal-wrapper'])} {...modalProps}>
      {children}
    </CatModal>
  );
};
